import { PagedData } from "@/services/models/shared/PagedData";
import { AxiosResponse } from "axios";
import {
  LeaseIDTFilterOptions,
  LeaseIDTListItem,
  NewLeaseIDT,
  UpdateLeaseIDT,
} from "@/services/models/LeaseIDT";
import BimsHttpService from "@/services/BimsHttpService";
import FileProvider from "@/utilities/providers/FileProvider";

class LeaseIDTService {
  /**
   * @description Returns a paged list of Lease IDTs.
   */
  getLeaseIDTs(
    filter: LeaseIDTFilterOptions
  ): Promise<PagedData<LeaseIDTListItem>> {
    return BimsHttpService.get(`/leaseIDTs`, {
      params: filter,
    }).then((response: AxiosResponse<PagedData<LeaseIDTListItem>>) => {
      return response.data as PagedData<LeaseIDTListItem>;
    });
  }

  /**
   * @description Returns the current lease IDT number
   */
  getCurrentLeaseIDTNumber(): Promise<number | null> {
    return BimsHttpService.get("/leaseIDTs/Number").then((response: AxiosResponse<number | null>) => {
      return response.data as number | null;
    });
  }

  /**
   * @description Adds a new lease IDT
   */
  addLeaseIDT(leaseIDT: NewLeaseIDT): Promise<any> {
    return BimsHttpService.post(`/leaseIDTs`, leaseIDT);
  }

  /**
 * @description Updates the lease IDT
 */
  updateLeaseIDT(leaseIDT: UpdateLeaseIDT): Promise<any> {
    return BimsHttpService.put(`/leaseIDTs`, leaseIDT);
  }

  /**
   * @description Creates a new lease IDT Number.
   */
  createLeaseIDTNumber(idtNumber: string): Promise<boolean> {
    return BimsHttpService.post(`/leaseIDTs/number`, {
      IDTNumber: idtNumber,
    });
  }
  /**
   * @description Fetches the total amount charged from the backend.
   */
  getTotalAmountCharged(): Promise<number> {
    return BimsHttpService.get(`/leaseIDTs/total`)
      .then((response: AxiosResponse<number>) => {
        return response.data;
      });
  }

  /**
   * @description Deletes a lease IDT with the specified SL, SA, and Famis Department
   */
  deleteLeaseIDT(sl: string, sa: string, famisDepartment: string): Promise<any> {
    return BimsHttpService.delete(`/leaseIDTs/${famisDepartment}/${sl}-${sa}`);
  }

  /**
   * @description Downloads the CSV export for the base account listing
   */
  public downloadLeaseIDTFrozenAndMissingAccounts(): Promise<any> {
    return BimsHttpService.get(`/leaseIDTs/accounts/frozenAndMissing/report`).then(response => {
      return FileProvider.ForceFileDownload(response)
    })
  }
}

export default new LeaseIDTService();
